package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class TeamData<T>(
    val number: Int,
    val name: String,
    val seasons: List<Int>?,
    val data: T,
)

inline fun <reified T> TeamData<MetricsAPI<Short>>.castOrNull(): TeamData<T>? {
    if (data !is T) return null
    @Suppress("UNCHECKED_CAST")
    return this as TeamData<T>
}

inline fun <reified T> TeamData<MetricsAPI<Short>>.cast() = castOrNull<T>() ?: error("${data::class} is not ${T::class}")
